import { AfterViewInit, Component, DestroyRef, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { PortalService } from '../../../../../services/portal/portal.service';
import { SignInViewModel } from './sign-in-view-model';
import { ButtonTypeEnum } from '../../../../../ui/buttons/button/button-type.enum';
import { PortalType } from '../../../../../models/enum/shared/portal-type';
import { SignInRequest } from '../../../../../models/users/requests/sign-in-request';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Routes } from '../../../../../../routes/routes';
import { EmailInputComponent } from '../../../../../ui/form-components/email-input/email-input/email-input.component';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  providers: [SignInViewModel],
  styleUrls: ['./sign-in.component.scss', '../auth.component.scss']
})
export class SignInComponent implements AfterViewInit {
  private viewModel = inject(SignInViewModel);
  private portalService = inject(PortalService);
  private destroyRef = inject(DestroyRef);
  private router = inject(Router);

  @Output() loadingOpts = new EventEmitter<LoadingOptions>();

  @ViewChild('emailInput', { static: true }) emailInput!: EmailInputComponent;

  private listenToLoadingOpts = this.viewModel.loadingOpts$
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(opts => this.loadingOpts.emit(opts));

  public formSubmitted = false;

  public formGroup = this.viewModel.formGroup;

  public readonly signInFailed$ = this.viewModel.signInFailed$;

  public customErrorMessages = {
    email: {
      required: $localize`Email is required`
    },
    password: {
      required: $localize`Password is required`
    }
  };

  public ngAfterViewInit(): void {
    this.emailInput.input.nativeElement.focus();
  }

  public signIn(): void {
    this.formSubmitted = true;
    if (this.formGroup.valid) {
      const { email, password } = this.formGroup.value;
      const req = new SignInRequest(email, password);
      this.portalService.portalType$.once(type => {
        switch (type) {
          case PortalType.Internal:
            this.viewModel.internalUserSignIn(req);
            break;
          case PortalType.Member:
            this.viewModel.memberSignIn(req);
            break;
          case PortalType.Employer:
            this.viewModel.employerSignIn(req);
            break;
        }
      });
    }
  }

  public forgotPassword(): void {
    const { email } = this.formGroup.value;
    this.router
      .navigate([Routes.forgotPassword()], {
        queryParams: { email: email || null }
      })
      .then();
  }

  protected readonly ButtonTypeEnum = ButtonTypeEnum;
}
